import { render, staticRenderFns } from "./m-chainCard.vue?vue&type=template&id=42fc01de&scoped=true&"
import script from "./m-chainCard.vue?vue&type=script&lang=ts&"
export * from "./m-chainCard.vue?vue&type=script&lang=ts&"
import style0 from "./m-chainCard.vue?vue&type=style&index=0&id=42fc01de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fc01de",
  null
  
)

export default component.exports